import React from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import {withStyles} from "@material-ui/core/styles";

const styles = {
    center: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center'
    }
};

const EmptyState = (props) => {
    const {classes} = props;
    const {icon, title, description, button} = props;

    return (
        <div className={classes.center}>
            {icon}
            {title && <Typography color="textSecondary" variant="h4">{title}</Typography>}
            {description && <Typography color="textSecondary" variant="subtitle1">{description}</Typography>}
            {button}
        </div>
    );
};

EmptyState.propTypes = {
    classes: PropTypes.object.isRequired,
    icon: PropTypes.element,
    title: PropTypes.string,
    description: PropTypes.string,
    button: PropTypes.element
};

export default withStyles(styles)(EmptyState);